export default "__VITE_ASSET__BvRTN40L__"